import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { Logger, LoggerTypes } from '../../../utils'

export const SimulationActionDialogWrapper = ({ DialogClass, openDialog, setOpenDialog, extraDialogAttribute }) => {
  const ref = createRef()

  Logger.trace(LoggerTypes.CONTAINER, 'SimulationActionDialogWrapper.render()', { DialogClass, setOpenDialog })

  return <DialogClass ref={ref} openDialog={openDialog} setOpenDialog={setOpenDialog} {...extraDialogAttribute} />
}

SimulationActionDialogWrapper.displayName = 'SimulationActionDialogWrapper'

SimulationActionDialogWrapper.propTypes = {
  DialogClass: PropTypes.any.isRequired,
  openDialog: PropTypes.bool,
  setOpenDialog: PropTypes.func,
  extraDialogAttribute: PropTypes.shape({
    title: PropTypes.string,
    dispatchAction: PropTypes.func
  }),
  isPopupVisible: PropTypes.bool
}

SimulationActionDialogWrapper.defaultProps = {
  DialogClass: Component,
  openDialog: false,
  setOpenDialog: () => {},
  extraDialogAttribute: {}
}

export default SimulationActionDialogWrapper
